import { useSpaceDomainStore } from '@common/stores/space-domain-store';

export const useSpaceDomain = () => {
  const configuration = useSpaceDomainStore(state => state.configuration);
  const hostname = window.location.hostname;

  return import.meta.env.VITE_SPACE_DOMAIN_OVERWRITE ?? configuration?.domain ?? hostname;
};